import { Reveal, Eyebrow } from "./Reveal";
import { SERVICES } from "../../data/site";

export const Services = () => (
  <section id="services" data-testid="services-section" className="section bg-[var(--forest)] text-white">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow light>What we build</Eyebrow>
          <h2 className="section-title mt-4 text-white">Services</h2>
        </div>
        <p className="max-w-md text-white/70">Forest fencing, wildlife and irrigation works across Karnataka. Each service is backed by completed, certified government contracts listed in the works register below.</p>
      </Reveal>
      <div className="mt-16 grid gap-px bg-white/10 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className="group bg-[var(--forest)]" data-testid={`service-card-${i}`}>
            <div className="overflow-hidden">
              <img src={s.img} alt={s.title} loading="lazy" className="aspect-[16/10] w-full object-cover opacity-85 transition-[transform,opacity] duration-700 group-hover:scale-105 group-hover:opacity-100" />
            </div>
            <div className="p-7">
              <p className="font-mono text-xs uppercase tracking-wider text-[var(--rust-light)]">{s.code}</p>
              <h3 className="mt-3 font-display text-3xl font-bold uppercase leading-none">{s.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-white/70">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
